<template>
  <div
    id="news"
    :style="{
      backgroundImage: 'url(' + require('../assets/images/news-bg.svg') + ')',
    }"
  >
    <div class="container">
      <div
        v-for="item in news"
        class="media mb-5 row justify-content-between align-items-center"
      >
        <div
          class="mr-md-3 col-md-2 news-img"
          :style="{
            backgroundImage:
              'url(' + require('../assets/images/' + item.img) + ')',
          }"
        ></div>
        <div class="media-body col-md-10">
          <h5 class="mt-0">{{ item.title }}</h5>
          {{ item.text }}
          <router-link v-if="item.link" :to="item.link"
            >Descubre cómo</router-link
          >
          <a
            href="#"
            @click.prevent="item.show = !item.show"
            v-if="item.longText"
            >Seguir</a
          >
          <transition v-if="item.longText" name="zoom" mode="out-in">
            {{ item.show }}
            <div v-if="item.show" v-html="item.longText"></div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      news: [
        {
          img: "news01-Redes.jpg",
          title: "Un touch más de Jabruta: Jabrutouch en las redes",
          text:
            "En Instagram y Facebook, nuevos contenidos se suman cada semana a las clases disponibles en la app, para estar más cerca de ti y acompañarte en el descubrimiento de la fuente principal del judaísmo.",
          show: false,
          longText:
            "<p>La aplicación de Jabrutouch permite estudiar las más de 4000 horas de clases de Guemará. Ahora, además, Jabrutouch está presente en redes sociales, para que puedas descubrir el Talmud de una manera más simple y amena.</p><p>Bajo la guía del Rav Yehoshua Benzadón, en las redes de Jabrutouch podrás conocer algunos de los conceptos principales de la porción de Talmud de cada semana, y compartir ideas junto a los más de 7000 usuarios que estudian gracias a la aplicación.</p><p>¡Síguenos en Instagram (<a href='https://www.instagram.com/jabrutouch_es/'>@jabrutouch_es</a>) y Facebook (<a href='https://www.facebook.com/JabrutouchTashema'>Jabrutouch/Tashema</a>) y escribamos juntos el futuro del Talmud!</p>",
        },
        {
          img: "news1.jpg",
          title: "Jabrutouch prepara una revolución en el Talmud",
          text:
            "Nuestro equipo está desarrollando una nueva versión de la app que cambiará la forma de estudiar el Talmud; y tú puedes formar parte de este proyecto.",
          link: "/participa",
        },
        {
          img: "news03-Aishlow.jpg",
          title:
            "Las tecnologías, claves para la pasión de Jabrutouch por la educación judía",
          text:
            "Jabrutouch participa de clases en instituciones educativas de América Latina e Israel en forma presencial y virtual.",
          show: false,
          longText:
            "<p>La misión de transmitir la Torá a todos los yehudim de habla hispana no se detuvo frente a la pandemia de COVID-19. En cambio, desde 2020 el equipo rabínico de Jabrutouch hizo uso cada vez más frecuente de plataformas digitales, para complementar los contenidos de la app con formas de encontrarse en vivo y profundizar el estudio a pesar de la distancia, en clases especiales, colaboraciones con instituciones y a través de consultas individuales y grupales.</p><p>    Como cada vez que quienes siguen el programa Daf Yomi concluyen la lectura de un tratado del Talmud, el cierre del último Masejet (Eruvin) fue la ocasión de un encuentro en vivo. Esta vez, gracias a la invitación de TuTorah.tv, el Siyum Masejet Eruvin fue compartido con Rabanim de comunidades de Argentina (Adjut Israel), México (Keter Torah), Panamá (R. David Perets), EEUU (Sinagoga Safra) y Venezuela (Kolel Nahalat Yaacob y Centro Beth Shemuel).</p><p>    Recientemente, R. Saúl Benzadón debatió junto a miembros de programas educativos en Israel acerca del concepto de emuná y las relaciones entre judaísmo y ciencia. Por su parte, en enero de 2021, R. Yehoshua Benzadón participó de una clase especial para Aish Chile, donde explicó un poderoso método visual para desmenuzar las enseñanzas de la Guemará. Y cada semana, decenas de alumnos, adolescentes y adultos, toman su guía para apuntalar sus estudios.</p><p>¿Quieres participar de un encuentro en vivo con el equipo de Jabrutouch? <a href='/nosotros#contacto'>Contáctanos</a>.</p>",
        },
      ],
      index: 0,
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
#news {
  min-height: 700px;
  padding: 60px 0;
  background-position: center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  margin-bottom: 60px;
  .news-img {
    min-height: 150px;
    background-size: cover;
    border-radius: 10px;
  }
  @media (max-width: 544px) {
    .news-img {
      min-height: 300px;
      background-size: cover;
      margin: 15px;
      border-radius: 10px;
    }
  }
}
.image-placeholder {
  width: 240px;
  background: #eee;
  border-radius: 10px;
  display: block;
  height: 180px;
  background-size: cover;
}
</style>